import AppLogoIcon from "./app-logo-icon"

export default function AppLogo() {
  return (
    <div className="flex items-center gap-2.5">
      <AppLogoIcon className="size-8 shrink-0 rounded-sm" />
      <span className="font-serif text-lg leading-none font-black tracking-tight">
        Broadside
      </span>
    </div>
  )
}
